import PropTypes from 'prop-types';

export const ProductItemDefaultProps = {
  className: '',
  selectedItem: null,
  onSelect: () => null,
};

export const ProductItemPropTypes = {
  className: PropTypes.string,
  selectedItem: PropTypes.object,
  item: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types
    children: PropTypes.array,
    depth: PropTypes.number,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    image: PropTypes.shape({
      alt: PropTypes.string,
      url: PropTypes.string,
    }),
    isLeaf: PropTypes.bool,
    name: PropTypes.string,
    path: PropTypes.string,
  }).isRequired,
  onSelect: PropTypes.func,
};
